// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:58:42

export default {
  "id": "gluttony",
  "slug": "gluttony",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d63712f336014ca4825cf174633bf19b-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d63712f336014ca4825cf174633bf19b/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Gluttony",
      "description": "In Gluttony, you control a giant hole with an endless appetite! Move around, swallow everything in sight, and grow bigger. But be careful—you're allergic to the little cute monsters! Avoid them at all costs while feasting on everything else.",
      "instructions": "1. Move the hole to devour everything in sight.\n2. Avoid the little cute monsters—they're dangerous!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "hole"
      ]
    },
    "zh-CN": {
      "title": "贪食",
      "description": "在《贪食》中，你操控一个拥有无尽食欲的巨型黑洞！四处移动，吞噬眼前的一切，让自己变得更大。但要注意——你对那些可爱的小怪物过敏！不惜一切代价避开它们，尽情享用其他一切。",
      "instructions": "1. 移动洞穴吞噬视野内的一切。\n2. 避免那些可爱的小怪物——它们很危险！",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "洞"
      ]
    },
    "zh-TW": {
      "title": "貪食",
      "description": "在《饕食》中，你操控一個無盡食慾的巨洞！移動四處，吞噬眼前所有事物，並變得更大。但請小心——你對那些可愛的小怪物過敏！在進行盛宴的時候，不惜一切代價避免它們。",
      "instructions": "1. 移動洞穴，吞噬眼前一切。\n2. 避開那些可愛的小怪物——他們很危險！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1玩家",
        "洞"
      ]
    },
    "zh-HK": {
      "title": "饕餮",
      "description": "在《饕餮》中，你操控一個無盡餓腹的巨洞！移動四處，吞噬眼前所有事物，並變得更大。但要注意——你對那些可愛的小怪物過敏！盡量避免他們，同時盡情享用其他一切。",
      "instructions": "1. 移動洞孔吞噬眼前所有事物。\n2. 避開那些可愛的小怪物——他們很危險！",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人玩家",
        "洞"
      ]
    },
    "ja": {
      "title": "汎食症",
      "description": "Gluttonyで、無尽蔵の食欲を持つ巨大な穴を操ります！動き回り、目の前のすべてを呑み込み、大きくなっていきましょう。しかし、注意してください—あなたは小さな可愛いモンスターにアレルギーです！食べるもの以外は一切避けましょう。",
      "instructions": "1. 洞を動かして見えるすべてを呑み込め。\n2. 小さくて可愛いモンスターを避けろー危険だよ！",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "ホール"
      ]
    },
    "ko": {
      "title": "욱식욕",
      "description": "《Gluttony》에서는 끝없는 배고픔을 가진 거대한 구멍을 제어합니다! 움직이고 보이는 모든 것을 삼키고 커지세요. 하지만 주의하세요 — 작은 귀여운 몬스터에 알레르기가 있습니다! 모든 것을 먹다가도 그들을 피하세요.",
      "instructions": "1. 공을 움직여 모든 것을 먹여버리세요.\n2. 작고 귀여운 몬스터를 피하세요—they're dangerous!",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "홀"
      ]
    },
    "fr": {
      "title": "Gourmandise",
      "description": "Dans Gloutonnerie, vous contrôlez un trou géant aux appétits sans fin ! Déplacez-vous, avaler tout ce qui se présente à vous, et grandissez. Mais soyez prudent — vous êtes allergique aux petits monstres mignons ! Évitez-les à tout prix pendant que vous festuez avec tout le reste.",
      "instructions": "1. Déplacez le trou pour manger tout ce qui est en vue.\n2. Évitez les petits monstres mignons—they're dangerous!",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1 joueur",
        "trou"
      ]
    }
  }
};
